
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 3h-2v10h2V3m4.83 2.17l-1.42 1.42A6.944 6.944 0 0119 12a7 7 0 01-7 7A6.995 6.995 0 017.58 6.58L6.17 5.17a9.001 9.001 0 00-1.03 12.69c3.22 3.78 8.9 4.24 12.69 1.02A9.003 9.003 0 0021 12c0-2.63-1.16-5.13-3.17-6.83z"}})])
          )
        }
      }
    